module.exports = __webpack_public_path__ + "components/zebra-list/static/flag-f59bdd957d26e88b8b31b2d8d1de08f4.svg";